<template>
  <div class="tw-text-center tw-mb-10 tw-text-4xl tw-font-bold">
    {{ errorTitle }}
  </div>
  <div class="tw-text-center tw-mb-10 tw-text-xl">
    <div v-if="errorCode == 'loggedout'">
      <p>You are currently logged out.</p>
      <p>Please login and try again.</p>
    </div>
    <div v-else-if="errorCode == 'baddata'">
      <p>There is an error in the data you have entered.</p>
      <p>Please try again.</p>
      <p>
        If the problem persists please
        <ContactLink @contact="$emit('close')" />.
      </p>
    </div>
    <div v-else>
      <div>
        <p>There was an error with your request</p>
        <p>Please try again.</p>
        <p>
          If the problem persists please
          <ContactLink @contact="$emit('close')" />.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ContactLink from "./ContactLink.vue";
import { SfApiError } from "@/types/generalTypes";

export default defineComponent({
  components: { ContactLink },
  emits: ["close"],
  props: {
    error: { type: Object as PropType<SfApiError | null> },
  },
  data() {
    return {};
  },
  computed: {
    errorCode(): string {
      switch (this.error?.message) {
        case "loggedout":
          return "loggedout";
        case "baddata":
          return "baddata";
      }
      return "uknown";
    },
    errorTitle(): string {
      return "Error";
    },
  },
});
</script>
